export default __webpack_public_path__ + "static/media/book.f44fc4f2.png";